import { createSlice } from '@reduxjs/toolkit';
import { Status } from 'ui-widgets';
import { getLaucnhesThunk } from '../../api/launches';

export type Launch = {
  campaign_id: string;
  template: string;
  title: string;
  content?: string;
  description: string;
  start_date: string;
  end_date: string;
  url: string;
  slug?: string | null;
  image: string;
  priority: string;
  image_url: string;
  subtitle?: string;
  label?: string;
};

interface State {
  launches: Launch[] | null;
  status: Status;
  error: null | string;
}

export const initialState: State = {
  launches: null,
  status: Status.IDLE,
  error: null,
};

const launchesSlice = createSlice({
  name: 'laucnhesSlice',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getLaucnhesThunk.pending, (state) => {
      state.status = Status.LOADING;
    });
    builder.addCase(getLaucnhesThunk.fulfilled, (state, action) => {
      state.launches = action.payload;
      state.status = Status.LOADED;
    });
    builder.addCase(getLaucnhesThunk.rejected, (state, action) => {
      state.error = action.payload?.message || null;
      state.status = Status.ERROR;
    });
  },
});

export const {} = launchesSlice.actions;

export default launchesSlice.reducer;
